// 实盘交易前端类型（v0）。
// account/balance/positions 字段对齐 MBO 真实返回（见 docs/integration.md）；
// 因 agent 后端对这三者是「薄透传」，BFF 拿到的即 MBO 原始 shape。
// LiveRun 是 BFF 透传后的 shape：后端 run 层实为 mode=live 的 shadow-run，
// BFF 直接透传整条 ShadowRunSummary（不再裁字段），故 LiveRun = ShadowRunSummary 别名。
import type { ShadowRunSummary } from '@/lib/backtest/types';

export type LiveAccountStatus =
  | 'pending_init'
  | 'initializing'
  | 'active'
  | 'failed';

export interface BridgeDepositAddresses {
  btc: string;
  evm: string;
  svm: string;
  tron: string;
}

export interface LiveAccount {
  user_id: string;
  eoa_address: string | null;
  deposit_wallet_address: string | null; // 后端仍返回，UI 不再使用，保留
  bridge_deposit_addresses: BridgeDepositAddresses | null; // Bridge 多链地址
  referral?: string | null; // 后端有此字段，暂不展示
  status: LiveAccountStatus;
  error: string | null;
}

// 未开通占位：MBO 里还没这个用户时后端 /users/me 返回 404。回落成 pending_init，
// 让 UI 始终展示「开通入口」。服务端 overview 聚合与客户端 hook 共用此常量。
export const NOT_OPENED_ACCOUNT: LiveAccount = {
  user_id: '',
  eoa_address: null,
  deposit_wallet_address: null,
  bridge_deposit_addresses: null,
  status: 'pending_init',
  error: null,
};

export interface LiveBalance {
  balance: string; // 人类可读 USDC 字符串（后端已 ÷1e6）
  asset_type: 'COLLATERAL';
  is_paper?: boolean; // 仅 paper 模式出现
}

export interface LivePosition {
  asset: string; // token_id（持仓的结果代币）
  conditionId?: string;
  size: string;
  avgPrice: string;
  curPrice?: string;
  cashPnl?: string;
  title?: string;
  outcome?: string;
  is_paper?: boolean;
}

export type LiveRunStatus =
  | 'active'
  | 'paused'
  | 'stopped'
  | 'completed'
  | 'failed';

// BFF 透传：live run 即 mode=live 的 shadow-run，DTO 就是整条 ShadowRunSummary。
// 用别名保留 LiveRun 名字给既有 import（useLiveRuns 等）。字段用 ShadowRunSummary 的
// 真实命名（shadow_run_id/total_pnl/strategy_title/positions_value/...）。
export type LiveRun = ShadowRunSummary;
